import { forwardRef } from 'react'
import cn from 'classnames'
import { Typography } from 'src/shared/ui/Typography'

import type { CommonControllerProps } from './typing'
import styles from './index.module.css'

export const Controller = forwardRef<HTMLDivElement, CommonControllerProps>(
  (
    {
      children,
      className,
      fieldClassName,
      labelClassName,
      disabled,
      readOnly,
      filled,
      focused,
      label,
      hint,
      error,
      block,
      leftAddons,
      leftAddonsProps,
      rightAddons,
      rightAddonsProps,
      ...restProps
    },
    ref,
  ) => {
    const errorMessage = typeof error === 'boolean' ? '' : error

    return (
      <div
        className={cn(styles.component, className, {
          [styles.block]: block,
        })}
      >
        {label && (
          <Typography view="reg_14" tag="span" className={cn(styles.label, labelClassName)}>
            {label}
          </Typography>
        )}

        <div
          ref={ref}
          className={cn(fieldClassName, styles.inner, {
            [styles.disabled]: disabled || readOnly,
            [styles.filled]: filled,
            [styles.focused]: focused && !error,
            [styles.hasError]: error,
          })}
          {...restProps}
        >
          {leftAddons && (
            <div className={cn(styles.addons, styles.leftAddons, leftAddonsProps?.className)} {...leftAddonsProps}>
              {leftAddons}
            </div>
          )}

          <div className={styles.inputWrapper}>
            <div className={styles.input}>{children}</div>
          </div>

          {rightAddons && (
            <div className={cn(styles.addons, styles.rightAddons, rightAddonsProps?.className)} {...rightAddonsProps}>
              {rightAddons}
            </div>
          )}
        </div>

        {hint && !errorMessage && (
          <Typography view="reg_12" className={styles.hint}>
            {hint}
          </Typography>
        )}

        {errorMessage && (
          <Typography view="reg_12" className={styles.error}>
            {errorMessage}
          </Typography>
        )}
      </div>
    )
  },
)
